/**
 * A product's DEFAULT PRICE, as the default price book states it.
 *
 * ONE COMPONENT FOR CREATE AND EDIT TENANT. Create Tenant's product row drew
 * this inline; Edit Tenant drew no price at all, so an operator switching
 * Assistants or Cluvik AI on for an existing tenant could not see what it
 * costs or how it is billed (audit A, Phase 2 item 2, 6 Oct 2026). Extracted
 * so both screens render the same price, the same unit and the same remedy
 * from the same server row — never a second copy that can drift.
 *
 * Nothing here multiplies or formats money beyond two decimals: `price` is
 * the presentation row's `default_price`, resolved and worded on the server.
 * An unpriced product says which book it is missing from, never a zero.
 */
import React from 'react';
import { PriceRemedy } from './ProductAddons';

export default function DefaultPriceTag({
  code, price, onRecheck, rechecking, recheckError,
}) {
  if (!price) return null;
  return (
    <span className="ml-auto text-right text-xs leading-tight"
          data-testid={`price-${code}`}>
      <span className={`block font-medium ${
        price.priced ? 'text-foreground' : 'text-warning-text'}`}>
        {price.priced
          ? `${price.currency} ${Number(price.amount).toFixed(2)}`
          : price.display}
      </span>
      <span className="block text-muted-foreground"
            data-testid={`billing-unit-${code}`}>
        {price.billing_unit_label}
      </span>
      {/* Not a dead end: where the price goes, and a way to see it once it
          is there. */}
      {!price.priced && (
        <span className="block mt-0.5">
          <PriceRemedy remedy={price.remedy}
                       onRecheck={onRecheck} rechecking={rechecking}
                       testId={`price-remedy-${code}`} />
        </span>
      )}
      {!price.priced && recheckError && (
        <span className="block text-warning-text"
              data-testid={`price-recheck-error-${code}`}>
          {recheckError}
        </span>
      )}
    </span>
  );
}
